import { i18n } from '@/i18n'

const LABEL_FILTROS = [
  {
    id: 'id',
    idVista: [9, 15, 23, 40, 41, 44, 46, 48, 49, 50, 51, 80, 83],
    label: i18n.t('configurations.id')
  },
  {
    id: 'name',
    idVista: [2, 11, 12, 13, 40, 41, 43, 44, 46, 48, 49, 50, 51, 80, 81],
    label: i18n.t('configurations.name')
  },
  {
    id: 'name',
    idVista: [9, 15, 23],
    label: i18n.t('configurations.username')
  },
  {
    id: 'email',
    idVista: [4, 7, 9, 10, 15, 23, 27, 40, 41, 42, 46, 48, 49, 51, 60, 80],
    label: i18n.t('configurations.email')
  },
  {
    id: 'conPoderesDelegados',
    idVista: [4, 7, 9, 10, 15, 23, 27, 40, 41, 42, 46, 48, 49, 51, 60, 80],
    label: i18n.t('companies.dont_alert_delegated')
  },
  {
    id: 'company',
    idVista: [9, 15, 23, 41],
    label: i18n.t('configurations.company')
  },
  {
    id: 'role',
    idVista: [9, 15, 23, 41],
    label: i18n.t('configurations.rol')
  },
  {
    id: 'tipoAuth',
    idVista: [9, 15, 23, 41],
    label: i18n.t('configurations.tipo_auth')
  },
  {
    id: 'nombreTag',
    idVista: [1, 9, 23, 25],
    label: 'Etiqueta'
  },
  {
    id: 'Activo',
    idVista: [9, 23, 81, 88],
    label: i18n.t('app.active')
  },
  {
    id: 'verTodo',
    idVista: [9, 15, 23, 41],
    label: i18n.t('configurations.ver_todo')
  },
  {
    id: 'verTodoTags',
    idVista: [9, 15, 23, 41],
    label: i18n.t('configurations.ver_todo_tags')
  },
  {
    id: 'verTodoStatuses',
    idVista: [9, 15, 23, 40, 41, 46, 48, 49, 51, 80],
    label: i18n.t('configurations.ver_todo_statuses')
  },
  {
    id: 'verTodoCompanies',
    idVista: [9, 15, 23, 40, 41, 46, 48, 49, 51, 80],
    label: i18n.t('configurations.ver_todo_companies')
  },
  {
    id: 'conectado',
    idVista: [9, 23],
    label: i18n.t('configurations.connected')
  },
  {
    id: 'empresa',
    idVista: [1, 4, 6, 9, 13, 23, 25, 27, 29, 40, 44, 46, 48, 49, 50, 51, 53, 80, 81, 84, 86, 88, 90],
    label: i18n.t('app.client')
  },
  {
    id: 'distribuidor',
    idVista: [1, 4, 8, 9, 13, 23, 25, 27, 40, 44, 46, 48, 49, 50, 51, 53, 80, 81, 84, 86, 88, 90],
    label: i18n.t('distributors.distributor')
  },
  {
    id: 'certAsociado',
    idVista: [4],
    label: i18n.t('companies.cert_asociado')
  },
  {
    id: 'cif',
    idVista: [4, 7, 10, 27, 42, 60, 81, 84],
    label: i18n.t('companies.cif')
  },
  {
    id: 'name',
    idVista: [4, 7, 10, 27, 42, 60],
    label: i18n.t('app.nombre_cif')
  },
  {
    id: 'automatic_download',
    idVista: [4, 7, 10, 27, 40, 42, 44, 48, 49, 50, 51, 60, 80],
    label: i18n.t('companies.automatic_download')
  },
  {
    id: 'codPGN',
    idVista: [4, 7, 10, 27, 42, 60],
    label: i18n.t('app.location_link')
  },
  {
    id: 'send_alerts',
    idVista: [4, 7, 10, 27, 40, 42, 46, 48, 49, 51, 60, 80],
    label: i18n.t('companies.send_alerts')
  },
  {
    id: 'fechaAltaDesde',
    idVista: [4, 7, 10, 27, 42, 60],
    label: i18n.t('companies.f_alta_desde')
  },
  {
    id: 'fechaAltaHasta',
    idVista: [4, 7, 10, 27, 42, 60],
    label: i18n.t('companies.f_alta_hasta')
  },
  {
    id: 'estado',
    idVista: [4, 7, 10, 27, 42, 60],
    label: i18n.t('companies.active')
  },
  {
    id: 'phone',
    idVista: [4, 7, 10, 27, 40, 42, 48, 49, 51, 60, 80],
    label: i18n.t('configurations.phone')
  },
  {
    id: 'activo',
    idVista: [8, 44, 50],
    label: i18n.t('companies.active')
  },
  {
    id: 'fechaDisposicionDesde',
    idVista: [1, 25],
    label: 'F. disposición desde'
  },
  {
    id: 'fechaDisposicionHasta',
    idVista: [1, 25],
    label: 'F. disposición hasta'
  },
  {
    id: 'fechaDescargaDesde',
    idVista: [1, 25],
    label: 'F. descarga desde'
  },
  {
    id: 'fechaDescargaHasta',
    idVista: [1, 25],
    label: 'F.  descarga hasta'
  },
  {
    id: 'fechaFinTramiteDesde',
    idVista: [1, 25],
    label: 'F. fin trámite desde'
  },
  {
    id: 'fechaFinTramiteHasta',
    idVista: [1, 25],
    label: 'F. fin trámite hasta'
  },
  {
    id: 'fechaHoraRegistroDesde',
    idVista: [1, 25],
    label: 'F. hora registro desde'
  },
  {
    id: 'fechaHoraRegistroHasta',
    idVista: [1, 25],
    label: 'F. hora registro hasta'
  },
  {
    id: 'tipo',
    idVista: [1, 25],
    label: 'Tipo'
  },
  {
    id: 'tipoNotif',
    idVista: [1, 25],
    label: 'Tipo'
  },
  {
    id: 'estadoDescargaExtra',
    idVista: [1, 25],
    label: 'Estado'
  },
  {
    id: 'sede',
    idVista: [1, 25],
    label: 'Sede'
  },
  {
    id: 'codPGN',
    idVista: [1, 25],
    label: 'Sede'
  },
  {
    id: 'idPGN',
    idVista: [1, 25],
    label: 'idPGN'
  },
  {
    id: 'estadoDescarga',
    idVista: [1, 25],
    label: 'Estado'
  },
  {
    id: 'asunto',
    idVista: [1, 25],
    label: 'Asunto'
  },
  {
    id: 'idInterno',
    idVista: [1, 25],
    label: 'Id Int'
  },
  {
    id: 'textoLibre',
    idVista: [1, 25],
    label: 'Contenido adjunto'
  },
  {
    id: 'ultimoError',
    idVista: [1, 25],
    label: 'Error temporal'
  },
  {
    id: 'ticketId',
    idVista: [1, 25, 90],
    label: 'Ticket ID'
  },
  {
    id: 'cifTitular',
    idVista: [1, 25],
    label: 'CIF Titular'
  },
  {
    id: 'cif',
    idVista: [1, 25],
    label: i18n.t('app.cif')
  },
  {
    id: 'NombreCIF',
    idVista: [1, 25, 81],
    label: 'Razón social'
  },
  {
    id: 'organismo',
    idVista: [1, 25, 62, 81],
    label: 'Organismo'
  },
  {
    id: 'organismo',
    idVista: [8],
    label: i18n.t('companies.organismo_excluded')
  },
  {
    id: 'fechaMigracionSolpheoFrom',
    idVista: [8],
    label: i18n.t('clients.fecha_migracion_solpheo_from')
  },
  {
    id: 'fechaMigracionSolpheoTo',
    idVista: [8],
    label: i18n.t('clients.fecha_migracion_solpheo_to')
  },
  {
    id: 'idTipoHSM',
    idVista: [8],
    label: i18n.t('clients.tipo_hsm')
  },
  {
    id: 'idTipoCliente',
    idVista: [8],
    label: i18n.t('clients.tipo_cliente')
  },
  {
    id: 'MaquinasNuestras',
    idVista: [8],
    label: i18n.t('clients.maquinas_nuestras')
  },
  {
    id: 'TieneMaquinas',
    idVista: [8],
    label: i18n.t('clients.tiene_maquinas')
  },
  {
    id: 'TercerosBasico',
    idVista: [8],
    label: i18n.t('clients.terceros_basico')
  },
  {
    id: 'soyPropietario',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.soy_propietario')
  },
  {
    id: 'agrupacionCIF',
    idVista: [1, 25],
    label: i18n.t('grouping.neos_by_cif')
  },
  {
    id: 'agrupacionSede',
    idVista: [1, 25],
    label: i18n.t('grouping.neos_by_sede')
  },
  {
    id: 'agrupacionOrganismo',
    idVista: [1, 25],
    label: i18n.t('grouping.neos_by_org')
  },
  {
    id: 'email',
    idVista: [1, 25],
    label: i18n.t('configurations.email_vinculado')
  },
  {
    id: 'nombreGrupoPropietarioAnterior',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.group_owner_last')
  },
  {
    id: 'TieneGrupoReparto',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.group_reparto')
  },
  {
    id: 'nombrePeticion',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.notificacionesPeticionSpecific')
  },
  {
    id: 'enviadoPeticion',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.notificacionesPeticion')
  },
  {
    id: 'emailEnviado',
    idVista: [1, 25],
    label: i18n.t('configurations.email_enviado')
  },
  {
    id: 'IdPGN',
    idVista: [16],
    label: i18n.t('locations.IdPGN')
  },
  {
    id: 'revisarTodo',
    idVista: [16],
    label: i18n.t('companies.revisar_todo')
  },
  {
    id: 'Codigo',
    idVista: [5, 16, 17, 72],
    label: i18n.t('configurations.code')
  },
  {
    id: 'Nombre',
    idVista: [5, 16, 17, 72],
    label: i18n.t('configurations.name')
  },
  {
    id: 'URL',
    idVista: [5, 16, 17, 61, 72],
    label: i18n.t('app.url')
  },
  {
    id: 'evento',
    idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 45, 47, 52, 73, 82, 87, 89, 91],
    label: 'Nombre del evento'
  },
  {
    id: 'eventoMultiple',
    idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 45, 47, 52, 73, 82, 87, 89, 91],
    label: 'Nombre del evento'
  },
  {
    id: 'mensaje',
    idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 45, 47, 52, 73, 82, 87, 89, 91],
    label: 'Información adicional'
  },
  {
    id: 'usuario',
    idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 45, 47, 52, 73, 82, 87, 89, 91],
    label: i18n.t('historical.user')
  },
  {
    id: 'fechaDesde',
    idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 45, 47, 52, 53, 73, 82, 87, 89],
    label: 'Fecha desde'
  },
  {
    id: 'fechaHasta',
    idVista: [18, 19, 20, 21, 22, 24, 26, 28, 30, 45, 47, 52, 53, 73, 82, 87, 89],
    label: 'Fecha hasta'
  },
  {
    id: 'name',
    idVista: [8],
    label: i18n.t('clients.name')
  },
  {
    id: 'EmailsContacto',
    idVista: [8],
    label: i18n.t('clients.EmailsContacto')
  },
  {
    id: 'codigoExterno',
    idVista: [8],
    label: i18n.t('clients.cod_ext')
  },
  {
    id: 'ns',
    idVista: [8],
    label: i18n.t('clients.ns')
  },
  {
    id: 'partner',
    idVista: [8],
    label: i18n.t('clients.partner')
  },
  {
    id: 'grupoVigilante',
    idVista: [8],
    label: i18n.t('clients.grupo_vigilante')
  },
  {
    id: 'tipoServicio',
    idVista: [8],
    label: i18n.t('clients.service_type')
  },
  {
    id: 'PendienteFacturacion',
    idVista: [8],
    label: i18n.t('clients.alta_fact_filter')
  },
  {
    id: 'FaseConfiguracion',
    idVista: [8],
    label: i18n.t('clients.fase_config')
  },
  {
    id: 'PaqueteContratacion',
    idVista: [8],
    label: i18n.t('clients.paquete_contratacion')
  },
  {
    id: 'certificadoSAML2Caducado',
    idVista: [8],
    label: i18n.t('clients.certificadoSAML2Caducado_filter')
  },
  {
    id: 'certificadoSAML2PorCaducar',
    idVista: [8],
    label: i18n.t('clients.certificadoSAML2PorCaducar_filter')
  },
  {
    id: 'expires_from',
    idVista: [6, 29, 85],
    label: 'Expira desde'
  },
  {
    id: 'expires_to',
    idVista: [6, 29, 85],
    label: 'Expira hasta'
  },
  {
    id: 'name',
    idVista: [6, 29, 85],
    label: 'Nombre'
  },
  {
    id: 'serial',
    idVista: [6, 29, 85],
    label: 'Serial'
  },
  {
    id: 'tipoCert',
    idVista: [6, 29, 85],
    label: i18n.t('certificates.type')
  },
  {
    id: 'enUso',
    idVista: [6, 29, 40, 46, 44, 48, 49, 50, 51, 80],
    label: i18n.t('tags.used')
  },
  {
    id: 'tieneDescripcion',
    idVista: [40],
    label: i18n.t('configurations.tiene_descripcion')
  },
  {
    id: 'propietario',
    idVista: [49, 51],
    label: i18n.t('app.owner')
  },
  {
    id: 'nombrecif',
    idVista: [14],
    label: i18n.t('app.organismo_cif')
  },
  {
    id: 'notas',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.notas')
  },
  {
    id: 'altaManual',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.alta_manual')
  },
  {
    id: 'DescargadaAutomaticamente',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.descargada_automaticamente')
  },
  {
    id: 'EnviarEmailError',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.eviar_email_error')
  },
  {
    id: 'NotificacionesPresentacionesError',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.presentations_error')
  },
  {
    id: 'notificacionesPeticionError',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.notificacionesPeticionError')
  },
  {
    id: 'errorHotfolder',
    idVista: [4],
    label: i18n.t('companies.errorHotfolder')
  },
  {
    id: 'sinVigilarHotfolder',
    idVista: [4],
    label: i18n.t('companies.sinVigilarHotfolder')
  },
  {
    id: 'metadato1',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.metadato')
  },
  {
    id: 'metadato2',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.metadato')
  },
  {
    id: 'metadato3',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.metadato')
  },
  {
    id: 'metadato4',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.metadato')
  },
  {
    id: 'tieneDestinatarioAutomatico',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.tieneDestinatarioAutomatico')
  },
  {
    id: 'tieneReglaAplicada',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.tieneReglaAplicada')
  },
  {
    id: 'reincidenciaErrores',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.ReincidenciaErrores')
  },
  {
    id: 'metadato5',
    idVista: [1, 25],
    label: i18n.t('notificationFilter.metadato')
  },
  {
    id: 'UsuarioResponsable',
    idVista: [1, 25],
    label: i18n.t('app.user_responsable')
  },
  {
    id: 'archivadas',
    idVista: [1],
    label: i18n.t('notificationFilter.archivadas')
  },
  {
    id: 'idEstadoSugerencia',
    idVista: [1],
    label: i18n.t('app.status_suggested')
  },
  {
    id: 'temporal',
    idVista: [10, 11, 12, 48],
    label: i18n.t('app.temporal')
  },
  {
    id: 'estadoDiasCortesiaAEAT',
    idVista: [4],
    label: i18n.t('companies.status_solicitud_coutersy_days')
  },
  {
    id: 'estadoDiasCortesiaAEATError',
    idVista: [4],
    label: i18n.t('companies.status_solicitud_coutersy_days_error')
  },
  {
    id: 'consultaDiasCortesiaAEATError',
    idVista: [4],
    label: i18n.t('companies.status_query_coutersy_days_error')
  },
  {
    id: 'alertaEmpresaDesactivada',
    idVista: [4],
    label: i18n.t('companies.alertaEmpresaDesactivada')
  },
  {
    id: 'tipoGrupo',
    idVista: [40, 46, 48, 49, 51, 80],
    label: i18n.t('configurations.type')
  },
  {
    id: 'verTodoGroups',
    idVista: [40, 46, 48, 49, 51, 80],
    label: i18n.t('configurations.ver_todo_groups')
  },
  {
    id: 'verTodoAsignarGrupos',
    idVista: [40, 46, 48, 49, 51, 80],
    label: i18n.t('configurations.ver_todo_groups_asign')
  },
  {
    id: 'nombreGrupo',
    idVista: [1, 9, 23, 25, 44, 50],
    label: i18n.t('notificationFilter.group')
  },
  {
    id: 'nombreAgrupacion',
    idVista: [4, 5, 7, 10, 16, 17, 42, 60, 61, 62],
    label: i18n.t('app.single_grouping')
  },
  {
    id: 'codPGN',
    idVista: [4, 5, 7, 10, 16, 17, 42, 60, 61, 62, 81],
    label: i18n.t('app.location_link')
  },
  {
    id: 'nombreGrupoPropietario',
    idVista: [1, 25, 44, 50, 81],
    label: i18n.t('notificationFilter.group_owner')
  },
  {
    id: 'prioridad',
    idVista: [44, 50],
    label: i18n.t('configurations.prioridad')
  },
  {
    id: 'EnDescarga',
    idVista: [44, 50],
    label: i18n.t('configurations.en_descarga')
  },
  {
    id: 'DetenerEjecucion',
    idVista: [44, 50],
    label: i18n.t('groups.detener_ejecucion')
  },
  {
    id: 'enviarAvisosUsuarios',
    idVista: [40, 46, 48, 49, 51, 80],
    label: i18n.t('configurations.send_alerts_users')
  },
  {
    id: 'name',
    idVista: [71],
    label: i18n.t('distributors.name')
  },
  {
    id: 'tipoDistribuidor',
    idVista: [71],
    label: i18n.t('distributors.tipo_distribuidor')
  },
  {
    id: 'tipoProvisionamiento',
    idVista: [71],
    label: i18n.t('distributors.tipo_provisionamiento')
  },
  {
    id: 'permiteWizard',
    idVista: [71],
    label: i18n.t('clients.permite_wizard')
  },
  {
    id: 'tipoImportacion',
    idVista: [53],
    label: i18n.t('imports.type')
  },
  {
    id: 'tipoImportacionEstado',
    idVista: [53],
    label: i18n.t('imports.status')
  },
  {
    id: 'usuario',
    idVista: [53],
    label: i18n.t('configurations.username')
  },
  {
    id: 'estadoDescargaExtra',
    idVista: [50],
    label: i18n.t('app.estado_destino')
  },
  {
    id: 'MomentoAplicacion',
    idVista: [50],
    label: i18n.t('rules.tipo_app')
  },
  {
    id: 'TemporizadorDias',
    idVista: [81],
    label: i18n.t('configflow.TemporizadorDias')
  },
  {
    id: 'EnviarCorreosPrincipales',
    idVista: [81],
    label: i18n.t('configflow.EnviarCorreosPrincipales')
  },
  {
    id: 'EnviarCorreosSecundarios',
    idVista: [81],
    label: i18n.t('configflow.EnviarCorreosSecundarios')
  },
  {
    id: 'email',
    idVista: [81],
    label: i18n.t('configflow.EmailGenerico')
  },
  {
    id: 'estadoOrigen',
    idVista: [81],
    label: i18n.t('app.estado_origen')
  },
  {
    id: 'estadoDestino',
    idVista: [81],
    label: i18n.t('app.estado_destino')
  },
  {
    id: 'codPGNMultiple',
    idVista: [8],
    label: 'Sedes'
  },
  {
    id: 'moduloMultiple',
    idVista: [8],
    label: 'Módulos'
  },
  {
    id: 'Tramite',
    idVista: [83],
    label: i18n.t('presentations.Tramite')
  },
  {
    id: 'CodigoTramite',
    idVista: [83],
    label: i18n.t('presentations.CodigoTramite')
  },
  {
    id: 'DescripcionTramite',
    idVista: [83],
    label: i18n.t('presentations.DescripcionTramite')
  },
  {
    id: 'Asunto',
    idVista: [83],
    label: i18n.t('presentations.Asunto')
  },
  {
    id: 'Telefono',
    idVista: [83],
    label: i18n.t('presentations.Telefono')
  },
  {
    id: 'Email',
    idVista: [83],
    label: i18n.t('presentations.Email')
  },
  {
    id: 'PresentarRecurso',
    idVista: [83],
    label: i18n.t('presentations.PresentarRecurso')
  },
  {
    id: 'Observaciones',
    idVista: [83],
    label: i18n.t('presentations.Observaciones')
  },
  {
    id: 'NumAsiento',
    idVista: [83],
    label: i18n.t('presentations.NumAsiento')
  },
  {
    id: 'CSVRecibo',
    idVista: [83],
    label: i18n.t('presentations.CSVRecibo')
  },
  {
    id: 'URLRecibo',
    idVista: [83],
    label: i18n.t('presentations.URLRecibo')
  },
  {
    id: 'FechaPresentacionDesde',
    idVista: [83],
    label: i18n.t('presentations.FechaPresentacionDesde')
  },
  {
    id: 'FechaPresentacionHasta',
    idVista: [83],
    label: i18n.t('presentations.FechaPresentacionHasta')
  },
  {
    id: 'tipoPresentacionEstado',
    idVista: [1],
    label: i18n.t('presentations.Estado_NEO')
  },
  {
    id: 'enviarPeticionError',
    idVista: [1],
    label: i18n.t('notificationFilter.notificacionesPeticionError')
  },
  {
    id: 'tipoPresentacionEstado',
    idVista: [83],
    label: i18n.t('presentations.Estado')
  },
  {
    id: 'Error',
    idVista: [83],
    label: i18n.t('presentations.Error')
  },
  {
    id: 'Documento',
    idVista: [84],
    label: i18n.t('documentmaster.Documento'),
  },
  {
    id: 'Extension',
    idVista: [84],
    label: i18n.t('documentmaster.Extension'),
  },
  {
    id: 'CodigoTipoDocumento',
    idVista: [84],
    label: i18n.t('documentmaster.CodigoTipoDocumento'),
  },
  {
    id: 'DescripcionTipoDocumento',
    idVista: [84],
    label: i18n.t('documentmaster.DescripcionTipoDocumento'),
  },
  {
    id: 'CodigoOrganismo',
    idVista: [1, 25, 86],
    label: i18n.t('organismoprovincia.CodigoOrganismo'),
  },
  {
    id: 'NombreOrganismo',
    idVista: [1, 25, 86],
    label: i18n.t('organismoprovincia.NombreOrganismo'),
  },
  {
    id: 'CodigoProvincia',
    idVista: [1, 25, 86],
    label: i18n.t('organismoprovincia.CodigoProvincia'),
  },
  {
    id: 'NombreProvincia',
    idVista: [1, 25, 86],
    label: i18n.t('organismoprovincia.NombreProvincia'),
  },
  {
    id: 'Organismo',
    idVista: [86],
    label: i18n.t('app.organismo_zc'),
  },
  {
    id: 'NombreAccion',
    idVista: [88],
    label: i18n.t('peticionapi.NombreAccion'),
  },
  {
    id: 'TipoAutenticacion',
    idVista: [88],
    label: i18n.t('peticionapi.TipoAutenticacion'),
  },
  {
    id: 'Metodo',
    idVista: [88],
    label: i18n.t('peticionapi.Metodo'),
  },
  {
    id: 'ContentType',
    idVista: [88],
    label: i18n.t('peticionapi.ContentType'),
  },
  {
    id: 'Automatico',
    idVista: [88],
    label: i18n.t('peticionapi.Automatico_Grid'),
  },
  {
    id: 'EjecucionUnica',
    idVista: [88],
    label: i18n.t('peticionapi.EjecucionUnica'),
  },
  {
    id: 'NumDiligencia',
    idVista: [90],
    label: i18n.t('procedings.NumDiligencia')
  },
  {
    id: 'tipoDiligencia',
    idVista: [90],
    label: i18n.t('procedings.Tipo')
  },
  {
    id: 'tipoDiligenciaEstado',
    idVista: [90],
    label: i18n.t('procedings.Estado')
  },
  {
    id: 'NIFPagadora',
    idVista: [90],
    label: i18n.t('procedings.NIFPagadora')
  },
  {
    id: 'NIFDeudor',
    idVista: [90],
    label: i18n.t('procedings.NIFDeudor')
  },
  {
    id: 'CSV',
    idVista: [90],
    label: i18n.t('procedings.CSV')
  },
  {
    id: 'Error',
    idVista: [90],
    label: i18n.t('procedings.Error')
  },
]

export {
  LABEL_FILTROS
}
